import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { ArrowLeft, Trash2 } from "lucide-react";

import "../../styles/admin/admin-detail.css";
import "../../styles/admin/admin-form.css";

import config from "../../config";

const API_BASE_URL = String(
  config.apiBaseUrl || ""
).replace(/\/+$/, "");

export default function AdminUserDetail() {

  const navigate = useNavigate();

  const { id } = useParams();

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  // =========================
  // CORREO
  // =========================
  const [sendingEmail, setSendingEmail] =
    useState(false);

  const [emailMessage, setEmailMessage] =
    useState("");

  const [
    emailMessageType,
    setEmailMessageType
  ] = useState("");

  // =========================
  // CANCELACIÓN
  // =========================
  const [cancelling, setCancelling] =
    useState(false);

  const [cancelMessage, setCancelMessage] =
    useState("");

  const [
    cancelMessageType,
    setCancelMessageType
  ] = useState("");

  // =========================
  // ELIMINACIÓN DEFINITIVA
  // =========================
  const [deletingUser, setDeletingUser] =
    useState(false);

  const [deleteMessage, setDeleteMessage] =
    useState("");

  const [
    deleteMessageType,
    setDeleteMessageType
  ] = useState("");

  useEffect(() => {
    loadUser();
  }, [id]);

  // =====================================================
  // CARGAR USUARIO
  // =====================================================
  const loadUser = async () => {

    setLoading(true);
    setError("");

    setEmailMessage("");
    setEmailMessageType("");

    setCancelMessage("");
    setCancelMessageType("");

    try {

      const token =
        localStorage.getItem("token");

      if (!token) {
        throw new Error(
          "No hay sesión activa. Inicia sesión nuevamente."
        );
      }

      const response = await fetch(
        `${API_BASE_URL}/api/admin/users/${id}`,
        {
          method: "GET",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseText =
        await response.text();

      if (!response.ok) {
        throw new Error(
          responseText ||
            "No se pudo cargar el detalle del usuario"
        );
      }

      const data =
        responseText
          ? JSON.parse(responseText)
          : null;

      setUser(data);

    } catch (err) {

      setError(
        err.message ||
          "Ocurrió un error al cargar el usuario"
      );

      setUser(null);

    } finally {

      setLoading(false);
    }
  };

  // =====================================================
  // CORREO PENDING_PAYMENT
  // =====================================================
  const handleSendPendingPaymentEmail =
    async () => {

      setSendingEmail(true);

      setEmailMessage("");
      setEmailMessageType("");

      try {

        const token =
          localStorage.getItem("token");

        if (!token) {
          throw new Error(
            "No hay sesión activa. Inicia sesión nuevamente."
          );
        }

        const response = await fetch(
          `${API_BASE_URL}/api/admin/users/${id}/send-pending-payment-email`,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              Authorization:
                `Bearer ${token}`,
            },
          }
        );

        const responseText =
          await response.text();

        if (!response.ok) {
          throw new Error(
            responseText ||
              "No se pudo enviar el correo"
          );
        }

        setEmailMessage(
          responseText ||
            "Correo enviado correctamente."
        );

        setEmailMessageType("success");

      } catch (err) {

        setEmailMessage(
          err.message ||
            "Ocurrió un error al enviar el correo."
        );

        setEmailMessageType("error");

      } finally {

        setSendingEmail(false);
      }
    };

  // =====================================================
  // CANCELAR SUSCRIPCIÓN
  // =====================================================
  const handleRequestCancellation =
    async () => {

      const confirmed = window.confirm(
        "¿Confirmas que quieres marcar la cancelación de esta suscripción? " +
        "El usuario conservará el acceso hasta su próximo cobro; " +
        "después de esa fecha no se le volverá a cobrar."
      );

      if (!confirmed) return;

      setCancelling(true);

      setCancelMessage("");
      setCancelMessageType("");

      try {

        const token =
          localStorage.getItem("token");

        if (!token) {
          throw new Error(
            "No hay sesión activa. Inicia sesión nuevamente."
          );
        }

        const response = await fetch(
          `${API_BASE_URL}/api/admin/users/${id}/request-cancellation`,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json",

              Authorization:
                `Bearer ${token}`,
            },
          }
        );

        const responseText =
          await response.text();

        if (!response.ok) {
          throw new Error(
            responseText ||
              "No se pudo registrar la cancelación"
          );
        }

        setCancelMessage(
          responseText ||
            "Cancelación registrada correctamente."
        );

        setCancelMessageType("success");

        await loadUser();

      } catch (err) {

        setCancelMessage(
          err.message ||
            "Ocurrió un error al registrar la cancelación."
        );

        setCancelMessageType("error");

      } finally {

        setCancelling(false);
      }
    };

  // =====================================================
  // ELIMINAR DE PETFAM
  // =====================================================
  const handleDeleteUser =
    async () => {

      const firstConfirm =
        window.confirm(
          "¿Seguro que quieres eliminar este usuario de Petfam?\n\n" +
          "Se eliminarán su cuenta, sus mascotas y sus eventos, " +
          "y también será dado de baja en Medismart.\n\n" +
          "Esta acción no se puede deshacer."
        );

      if (!firstConfirm) {
        return;
      }

      const secondConfirm =
        window.confirm(
          "CONFIRMACIÓN FINAL\n\n" +
          `¿Eliminar definitivamente a ${user?.email || "este usuario"}?`
        );

      if (!secondConfirm) {
        return;
      }

      setDeletingUser(true);

      setDeleteMessage("");
      setDeleteMessageType("");

      try {

        const token =
          localStorage.getItem("token");

        if (!token) {
          throw new Error(
            "No hay sesión activa. Inicia sesión nuevamente."
          );
        }

        const response = await fetch(
          `${API_BASE_URL}/api/admin/users/${id}`,
          {
            method: "DELETE",

            headers: {
              "Content-Type":
                "application/json",

              Authorization:
                `Bearer ${token}`,
            },
          }
        );

        const responseText =
          await response.text();

        if (!response.ok) {

          throw new Error(
            responseText ||
              "No se pudo eliminar el usuario"
          );
        }

        setDeleteMessage(
          responseText ||
            "Usuario eliminado correctamente."
        );

        setDeleteMessageType("success");

        // Volver a la lista
        setTimeout(() => {

          navigate(
            "/admin/usuarios",
            {
              replace: true,
            }
          );

        }, 600);

      } catch (err) {

        setDeleteMessage(
          err.message ||
            "Ocurrió un error al eliminar el usuario."
        );

        setDeleteMessageType("error");

      } finally {

        setDeletingUser(false);
      }
    };

  // =====================================================
  // FECHAS
  // =====================================================
  const formatDate = (value) => {

    if (!value) return "-";

    try {

      return new Date(
        value
      ).toLocaleDateString(
        "es-CO"
      );

    } catch {

      return "-";
    }
  };

  // =====================================================
  // LOADING
  // =====================================================
  if (loading) {

    return (

      <div className="admin-page">

        <div className="admin-page-head">

          <div>

            <h2>
              Detalle de usuario
            </h2>

            <p>
              Cargando información...
            </p>

          </div>

        </div>

      </div>
    );
  }

  // =====================================================
  // ERROR
  // =====================================================
  if (error && !user) {

    return (

      <div className="admin-page">

        <div className="admin-page-head">

          <div>

            <h2>
              Detalle de usuario
            </h2>

            <p>
              Información general del usuario
            </p>

          </div>

        </div>

        <p className="admin-form-message error">
          {error}
        </p>

      </div>
    );
  }

  if (!user) {

    return (

      <div className="admin-page">

        <div className="admin-page-head">

          <div>

            <h2>
              Detalle de usuario
            </h2>

            <p>
              No se encontró información del usuario
            </p>

          </div>

        </div>

      </div>
    );
  }

  const fullName =
    `${user.name || ""} ${user.lastName || ""}`.trim();

  const normalizedStatus =
    String(
      user.status ?? ""
    )
      .normalize("NFKC")
      .toUpperCase();

  const showPendingButton =
    normalizedStatus.includes(
      "PENDING_PAYMENT"
    );

  const showCancelButton =
    Boolean(
      user.subscriptionActive
    ) &&
    !Boolean(
      user.cancellationRequested
    );

  const busy =
    deletingUser ||
    cancelling ||
    sendingEmail;

  return (

    <div className="admin-page">

      <div className="admin-page-head admin-detail-topbar">

        <div className="admin-detail-head-left">

          <button
            type="button"
            className="admin-back-arrow-btn"
            onClick={() =>
              navigate(
                "/admin/usuarios"
              )
            }
            title="Volver"
            disabled={busy}
          >

            <ArrowLeft size={20} />

          </button>

          <div>

            <h2>
              Detalle de usuario
            </h2>

            <p>
              Información general del usuario
            </p>

          </div>

        </div>

      </div>

      {error ? (

        <p className="admin-form-message error">
          {error}
        </p>

      ) : null}

      <div className="detail-grid">

        {/* ======================
            DATOS PERSONALES
        ====================== */}

        <section className="detail-card">

          <h3>
            Datos personales
          </h3>

          <div className="detail-list">

            <p>
              <strong>Nombre:</strong>{" "}
              {fullName || "-"}
            </p>

            <p>
              <strong>Correo:</strong>{" "}
              {user.email || "-"}
            </p>

            <p>
              <strong>Celular:</strong>{" "}
              {user.phone || "-"}
            </p>

            <p>
              <strong>Cédula:</strong>{" "}
              {user.dni || "-"}
            </p>

            <p>
              <strong>País:</strong>{" "}
              {user.country || "-"}
            </p>

            <p>
              <strong>
                Fecha de registro:
              </strong>{" "}
              {formatDate(
                user.registerDate
              )}
            </p>

          </div>

        </section>

        {/* ======================
            MASCOTAS
        ====================== */}

        <section className="detail-card">

          <h3>
            Mascotas
          </h3>

          <div className="detail-list">

            <p>
              <strong>
                Cantidad de mascotas:
              </strong>{" "}
              {user.petCount ?? 0}
            </p>

          </div>

        </section>

        {/* ======================
            ESTADO CUENTA
        ====================== */}

        <section className="detail-card">

          <h3>
            Estado de cuenta
          </h3>

          <div className="detail-list">

            <p>
              <strong>Estado:</strong>{" "}
              {user.status || "-"}
            </p>

            <p>
              <strong>
                Suscripción activa:
              </strong>{" "}
              {user.subscriptionActive
                ? "Sí"
                : "No"}
            </p>

            <p>
              <strong>
                Próximo cobro:
              </strong>{" "}
              {formatDate(
                user.nextChargeAt
              )}
            </p>

            <p>
              <strong>
                Proveedor de pago:
              </strong>{" "}
              {user.paymentProvider || "-"}
            </p>

            <p>

              <strong>
                Cancelación solicitada:
              </strong>{" "}

              {user.cancellationRequested

                ? `Sí (${formatDate(
                    user.cancellationRequestedAt
                  )})`

                : "No"}

            </p>

          </div>

          {/* ======================
              PENDING PAYMENT
          ====================== */}

          {showPendingButton && (

            <div className="admin-detail-inline-actions">

              <button
                type="button"
                className="admin-send-mail-btn"
                onClick={
                  handleSendPendingPaymentEmail
                }
                disabled={busy}
              >

                {sendingEmail
                  ? "Enviando..."
                  : "Enviar correo"}

              </button>

            </div>
          )}

          {emailMessage && (

            <p
              className={
                `admin-inline-message ${emailMessageType}`
              }
            >
              {emailMessage}
            </p>
          )}

          {/* ======================
              CANCELAR SUSCRIPCIÓN
          ====================== */}

          {showCancelButton && (

            <div className="admin-detail-inline-actions">

              <button
                type="button"
                className="admin-send-mail-btn"
                onClick={
                  handleRequestCancellation
                }
                disabled={busy}
              >

                {cancelling
                  ? "Registrando..."
                  : "Cancelar suscripción"}

              </button>

            </div>
          )}

          {cancelMessage && (

            <p
              className={
                `admin-inline-message ${cancelMessageType}`
              }
            >
              {cancelMessage}
            </p>
          )}

          {/* ======================
              ELIMINAR PETFAM
          ====================== */}

          <div
            className="admin-detail-inline-actions"
            style={{
              marginTop: 18,
              paddingTop: 18,
              borderTop:
                "1px solid rgba(0,0,0,.10)",
            }}
          >

            <button
              type="button"
              onClick={
                handleDeleteUser
              }
              disabled={busy}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                border: "none",
                borderRadius: 12,
                padding: "10px 16px",
                background: "#B42318",
                color: "#FFFFFF",
                fontWeight: 700,
                cursor:
                  busy
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  busy
                    ? 0.6
                    : 1,
              }}
            >

              <Trash2 size={17} />

              {deletingUser
                ? "Eliminando..."
                : "Eliminar de Petfam"}

            </button>

          </div>

          {deleteMessage && (

            <p
              className={
                `admin-inline-message ${deleteMessageType}`
              }
            >
              {deleteMessage}
            </p>
          )}

        </section>

      </div>

    </div>
  );
}